import z from "zod";
export const apiValidationIssueSchema = z.looseObject({
    code: z.string(),
    path: z.array(z.union([z.string(), z.number()])),
    message: z.string(),
});
export const apiErrorBodySchema = z.object({
    statusCode: z.int(),
    code: z.string(),
    message: z.string(),
    params: z.record(z.string(), z.unknown()).optional(),
    errors: z.array(apiValidationIssueSchema).optional(),
});
//# sourceMappingURL=error.schema.js.map